<template>
    <div class="editTar">
        <h3>{{$t('planner.Expenses')}}</h3>
        <div>
            <el-form :label-position="'top'" label-width="108px" ref="form" :model="form">
                <el-form-item :label="$t('planner.CurrentMonthlyExpenses')">
                    <div class="p-relative">
                        <span class="prepend placeholderPend">{{savings.currency_symbol}}</span>
                        <numeric-input type="number" v-model="form.current_annual_expenses"></numeric-input>
                        <span class="append placeholderPend">{{savings.currency_code}}</span>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('planner.RetirementMonthlyExpenses')">
                    <div class="p-relative">
                        <span class="prepend placeholderPend">{{savings.currency_symbol}}</span>
                        <numeric-input type="number" v-model="form.retirement_annual_expenses"></numeric-input>
                        <span class="append placeholderPend">{{savings.currency_code}}</span>
                    </div>
                </el-form-item>

                <h3>{{$t('planner.Target')}}</h3>

                <el-form-item :label="$t('planner.RealEstateAllocation')">
                    <div class="p-relative">
                        <span class="prepend placeholderPend">{{savings.currency_symbol}}</span>
                        <numeric-input type="number" v-model="form.real_estate_target"></numeric-input>
                        <span class="append placeholderPend">{{savings.currency_code}}</span>
                    </div>
                </el-form-item>
                <div
                    v-if="!collection.investment_calculating && collection.existing_investments.length > 0"
                >
                    <div class="hint-box">
                        {{$t('planner.YourRealEsatet')}}
                        <span>{{savings.currency_code}}{{savings.currency_symbol}}{{savings.real_estate.amount | NumFormat}}</span>
                    </div>
                    <p class="hint">{{$t('planner.BaseTotal')}}</p>
                </div>
                <div v-else>
                    <div class="hint-box">
                        {{$t('planner.YourRealEsatet')}}
                        <span>{{$t('planner.CurrentlyCalculating')}}</span>
                    </div>
                </div>
                <el-button type="primary" @click="submit">{{$t('planner.Confirm')}}</el-button>
            </el-form>
        </div>
    </div>
</template>

<script>
import numericInput from "@/components/common/numeric-input.vue";
let loading;

export default {
    name: "editTar",
    props: ["savings", "requestParams", "requestHeaders", "collection"],
    data() {
        const $t = this.$t.bind(this);
        return {
            form: {
                current_annual_expenses: this.savings.current_annual_expenses,
                retirement_annual_expenses: this.savings
                    .retirement_annual_expenses,
                real_estate_target: this.savings.real_estate_target
            }
        };
    },

    beforeMount() {},

    activated() {
        this.form.current_annual_expenses = this.savings.current_annual_expenses;
        this.form.retirement_annual_expenses = this.savings.retirement_annual_expenses;
        this.form.real_estate_target = this.savings.real_estate_target;
    },

    mounted() {},

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        submit() {
            this.loading();
            let allocationsUrl = `${this.requestParams.ppbApi}api/savings/`;
            let parameters = this.form;
            parameters.investment_interests = "RETURNS_2_5_YEARS";

            this.$http
                .patch(allocationsUrl, parameters, this.requestHeaders)
                .then(result => {
                    loading.close();
                    if (result.status == "200") {
                        this.$emit("goTo", "");
                    }
                })
                .catch(err => {});
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    watch: {},

    components: {
        numericInput
    }
};
</script>

<style lang="scss">
.editTar {
    .p-relative {
        position: relative;
        .el-form-item__label {
            width: 100% !important;
            margin-bottom: 10px;
            float: unset;
            padding: 0;
        }
        .el-form-item__content {
            margin: 0 !important;
        }
        .placeholderPend {
            position: absolute;
            top: 0;
            font-size: 14px;
            font-weight: 500;
            color: var(--brownish-grey);
        }
        .append {
            right: 16px;
            font-family: GothamMedium;
        }
        .prepend {
            left: 16px;
            font-family: GothamBook;
        }
        .el-input__inner {
            padding-left: 35px;
            height: 40px;
            border-radius: 4px;
            border: solid 1px #e0e7ff;
            background-color: rgba(224, 231, 255, 0.2);
        }
    }

    .el-form--label-top .el-form-item__label {
        height: auto;
        line-height: normal;
    }

    .hint-box {
        width: 100%;
        border-radius: 4px;
        box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
        background-color: #203862;
        padding: 12px 18px 12px 32px;
        margin-bottom: 10px;
        font-family: GothamBook;
        font-size: 12px;
        line-height: 1.5;
        color: var(--white);
        position: relative;
        &::before {
            content: "";
            display: inline-block;
            width: 13px;
            height: 13px;
            position: absolute;
            left: 11px;
            top: 14px;
            background: url("../../../../website_20/static/img/icon-tips.svg")
                no-repeat;
        }
        span {
            font-family: GothamMedium;
        }
    }

    .hint {
        width: 100%;
        margin-bottom: 30px;
        font-family: GothamBook;
        font-size: 12px;
        line-height: 1.2;
        color: var(--windows-blue);
    }

    .el-button {
        border: none;
        box-shadow: none;
        width: 100%;
        border-radius: 4px;
        background-color: var(--windows-blue);
        font-family: GothamMedium;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        color: var(--white);
        &:hover,
        &:focus {
            background-color: var(--windows-blue);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/editTar.vue